import "./styles.css";
import { isBoardId } from "../shared/types";
import { renderControlPage } from "./control-page";
import { renderCreatePage } from "./create-page";
import { element } from "./dom";
import { renderOverlayPage } from "./overlay-page";
import { requireSiteAccess } from "./site-gate";

const root = document.querySelector<HTMLElement>("#app");
if (!root) throw new Error("App-element ontbreekt.");
const app: HTMLElement = root;

const segments = location.pathname.split("/").filter(Boolean);
const route = segments[0] ?? "";
const boardId = segments[1] ?? "";

function renderNotFound(message: string): void {
  document.body.className = "app-body app-body--centered";
  const card = element("section", {
    className: "message-card",
    children: [
      element("p", { className: "eyebrow", text: "404" }),
      element("h1", { className: "message-card__title", text: "Pagina niet gevonden" }),
      element("p", { className: "message-card__text", text: message }),
      element("a", { className: "button button--primary", text: "Naar de startpagina", attrs: { href: "/" } }),
    ],
  });
  app.replaceChildren(card);
}

if (route === "overlay" && isBoardId(boardId) && segments.length === 2) {
  renderOverlayPage(app, boardId);
} else if (route === "control" && isBoardId(boardId) && segments.length === 2) {
  void requireSiteAccess(app, () => renderControlPage(app, boardId));
} else if (!route) {
  void requireSiteAccess(app, () => renderCreatePage(app));
} else {
  renderNotFound("Controleer of de URL van de bingokaart volledig is gekopieerd.");
}
